function positionScrolls() {
  const scrollElements = document.querySelectorAll('.scroll[data-layout]');

  function updateJustifyContent() {
    scrollElements.forEach(element => {
      if (element.scrollWidth > element.clientWidth) {
        element.style.justifyContent = 'flex-start';
      } else {
        element.style.justifyContent = 'center';
      }
    });
  }

  scrollElements.forEach(element => {
    const resizeObserver = new ResizeObserver(() => {
      updateJustifyContent();
    });
    resizeObserver.observe(element);
  });

  window.addEventListener('resize', () => {
    updateJustifyContent();
  });

  updateJustifyContent();
}

function alignScrollItemHeights() {
  const elements = document.querySelectorAll('.scroll[data-layout]');
  elements.forEach(element => {
    const items = Array.from(element.querySelectorAll('.scroll-item'));
    if (!items.length) return;

    items.forEach(i => i.style.minHeight = 'auto');
    const maxHeight = Math.max(...items.map(i => i.offsetHeight));
    items.forEach(i => i.style.minHeight = `${maxHeight}px`);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  positionScrolls();
});

document.addEventListener('DOMContentLoaded', () => {
  alignScrollItemHeights();
});

window.addEventListener('resize', alignScrollItemHeights);
